// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview:hover .card-body .asset-info.stay[data-v-03d53d0c]{opacity:1}.asset-preview .title[data-v-03d53d0c]{overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
